import SHWError from '@/common/error/SHWError'

export default function assertDefined<T>(val: T, message: string): asserts val is NonNullable<T> {
  if (val === undefined || val === null) {
    throw new SHWError({ internalMessage: `Assertion Failure: ${message}` })
  }
}
